import React from "react";
import SummaryChildLimitedDiscountContinue from "./SummaryChildLimitedDiscountContinue";
import SummaryChildGrandUpsellDiscount from "./SummaryChildGrandUpsellDiscount";
import SummaryChildNoDiscount from "./SummaryChildNoDiscount";

export default function SummaryBeforeAddToCart(props) {
  // PROPS COMING FROM PriceOffer
  const {
    isDiscountValid,
    isThereApendingOrder,
    price,
    normalisedQty,
    validPrice,
    product,
    cartSkuItems,
  } = props;

  return (
    <>
      {product.timeLimitedDiscount.discountAmount === 0 &&
      isThereApendingOrder !== "YES" ? (
        <SummaryChildNoDiscount normalisedQty={normalisedQty} price={price} />
      ) : normalisedQty > 0 &&
        ((cartSkuItems?.length > 0 && isDiscountValid) ||
          isThereApendingOrder === "YES") ? (
        <SummaryChildGrandUpsellDiscount
          normalisedQty={normalisedQty}
          price={price}
          product={product}
          validPrice={validPrice}
        />
      ) : normalisedQty > 0 &&
        !isDiscountValid &&
        product.timeLimitedDiscount.discountAmount > 0 ? (
        <SummaryChildNoDiscount normalisedQty={normalisedQty} price={price} />
      ) : normalisedQty > 0 && isDiscountValid ? (
        <SummaryChildLimitedDiscountContinue
          normalisedQty={normalisedQty}
          price={price}
          product={product}
          validPrice={validPrice}
          cartSkuItemsLength={cartSkuItems?.length}
        />
      ) : (
        ""
      )}
    </>
  );
}
